<template>
  <div class="member__server">
    <div class="title">学习服务</div>
    <div class="study__servers">
      <div class="study__server item1" @click="goStudy(1)">
        <div class="text">人工批改</div>
        <div class="desc">作业精准指导</div>
        <div class="icon"></div>
      </div>
      <div class="study__server item2" @click="goStudy(2)">
        <div class="text">人工答疑</div>
        <div class="desc">让问题不再无解</div>
        <div class="icon"></div>
      </div>
      <!-- <div :class="`study__server ${userMemberInfo.level === 30 ? 'item4' : 'item3'}`" @click="goStudy(3)">
        <div class="text">1对1择校</div>
        <div class="desc">精细化择校服务</div>
        <div class="icon"></div>
      </div> -->
    </div>

  </div>
</template>

<script>
import { reqSchemeUrl } from '@/api/openMini';
import { whatEev } from '@/utils/tools';
// import { getAcademyCountApi } from '@/api/archives/index';
import { getProductInfo } from '@/api/member/index';
import wx from 'weixin-js-sdk';

export default {
  props: {
    userInfo: {
      type: Object,
      default: () => ({}),
    },
    activeTab: {
      type: Number,
      value: 20,
    },
    userMemberInfo: {
      type: Object,
      default: () => ({
        level: 0, // 0 普通用户 10 试用会员 20 普通会员 30 高级会员
        levelName: '普通用户',
        deadlineStartTime: '',
        deadlineEndTime: '', // 会员到期时间
        isTryoutMember: null, // 是否领取过试用会员
        beforeMemberLevel: null, // 上一次会员等级
      }),
    },
    productId: {
      type: String,
      value: '',
    },
    showDownAppModal: {
      type: Function,
      default: () => { },
    },
  },
  data() {
    return {
      // num: 0,
      userProductId: '',
    };
  },
  methods: {
    goStudy(key) {
      // 没解锁无点击事件
      if (!this.isUnlock) return;
      switch (key) {
        case 1:
          this.correction();
          break;
        case 2:
          this.answerQuestion();
          break;
        default:
          this.chooseSchool();
      }
    },
    correction() {
      this.goPage('/pages/index/index', 'pigai');
    },
    // 跳转页面
    goPage(url, redirctPage = '') {
      if (whatEev() === 'miniprogram') {
        if (redirctPage) {
          wx.miniProgram.navigateTo({
            url: `/pages/redirectOtherMini/index?redirctPage=${redirctPage}`,
          });
        } else {
          wx.miniProgram.navigateTo({
            url,
          });
        }
      } else if (this.$root.$data.isApp) {
        if (redirctPage === 'pigai') {
          this.$sendToApp('goWechatProject', {
            userName: 'gh_affc8f949922',
            path: url,
          });
          return;
        }
        this.$sendToApp('goWechatProject', {
          userName: 'gh_5fb96ed24012',
          path: url,
        });
      } else {
        this.getSchemeUrl(url, redirctPage);
      }
    },
    // h5 打开小程序的方法
    async getSchemeUrl(path, redirctPage) {
      let data = {
        appid: 'wxdb89cfa2bb60f779',
        path,
        envVersion: !window.location.host.includes('mobile-test') ? 'release' : 'trial',
      };
      if (redirctPage === 'pigai') {
        data = {
          appid: 'wx28d0c1323b01e8d9',
          path,
          envVersion: !window.location.host.includes('mobile-test') ? 'release' : 'trial',
        };
      }

      const res = await reqSchemeUrl(data);
      if (res?.code === 0) {
        this.chatUrl = res.data;
        window.location.href = res.data;
      }
    },
    answerQuestion() {
      if (this.$root.$data.isApp) {
        if (this.userProductId) {
          this.$sendToApp('goToQuestionHome', { userProductId: this.userProductId });
        }
      } else {
        this.showDownAppModal();
      }
    },
    chooseSchool() {
      if (this.$root.miniprogram) {
        let url = window.location.href;
        const { origin } = window.location;
        // eslint-disable-next-line no-unused-vars
        const [domain, searchParams] = url.split('?');
        const params = searchParams.split('&');
        const paramsMap = new Map();
        params.forEach((item) => {
          const [key, value] = item.split('=');
          if (key) {
            paramsMap.set(key, value);
          }
        });
        const entries = paramsMap.entries();
        let query = '';
        const ExcludequeryArr = ['THIRD_SESSION', 'env'];
        // eslint-disable-next-line no-restricted-syntax
        for (const [key, value] of entries) {
          if (ExcludequeryArr.includes(key)) query += `${key}=${value}&beforePageName=8`;
        }
        url = `${origin}/ark/schoolChoose?${query}`;
        const path = `/subPackages/webView/webView?url=${encodeURIComponent(url)}`;
        wx.miniProgram.navigateTo({
          url: path,
        });
      } else if (this.$root.$data.isApp) {
        const { origin } = window.location;
        const url = `${origin}/ark/schoolChoose?hiddenNavigationBar=1`;
        this.$sendToApp('openNewWebView', { url }, false);
      } else {
        this.$router.push({
          path: '/schoolChoose',
        });
      }
    },
    // getChooseNum() {
    //   getAcademyCountApi().then((res) => {
    //     if (res.code === 0) {
    //       this.num = res.data;
    //     }
    //   });
    // },
  },
  computed: {
    isUnlock() {
      const { level } = this.userMemberInfo;
      const { id } = this.userInfo;
      const flag = id && ((level === 30 && this.activeTab === 30) || ([10, 20].includes(20) && this.activeTab === 20));
      return !!flag;
    },
  },
  watch: {
    productId: {
      handler(value) {
        if (value && this.userInfo.id) {
          getProductInfo(value).then((res) => {
            const { data, code } = res;
            if (code === 0) {
              this.userProductId = data[0]?.id || '';
            }
          });
        }
      },
      immediate: true,
    },
  },
  created() {
    // this.getChooseNum();
  },
};
</script>

<style scoped lang="scss">
@import '../../index.scss';

.member__server {
  width: 678px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0 auto 36px;
}

.title {
  width: 100%;
  margin-bottom: 22px;
  height: 40px;
  font-size: 29px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 40px;
}

.study__servers {
  width: 681px;
  background: linear-gradient(224deg, #FFDEAC 0%, #E3B177 100%);
  border-radius: 14px;
  padding: 18px 0;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;

  &::-webkit-scrollbar {
    display: none;
  }
}

.study__server {
  display: inline-flex;
  width:313px;
  height: 118px;
  background: #FFFFFF;
  border-radius: 11px;
  margin-left: 18px;
  overflow: hidden;
  position: relative;
  padding: 24px 22px;
  flex-direction: column;
  justify-content: space-between;
  vertical-align: middle;

  .text {
    font-size: 25px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 36px;
  }

  .desc {
    font-size: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 29px;
  }

  .icon {
    @include background(82px, 82px);

    position: absolute;
    top: 18px;
    right: 18px;
  }

  &.item1 {
    .icon {
      @include backgroundImage('member_pigai.png');
    }
  }

  &.item2 {
    .icon {
      @include backgroundImage('member_dayi.png');
    }
  }

  &.item3 {
    margin-right: 18px;

    .icon {
      @include backgroundImage('member_zexiao.png');
    }
  }

  &.item4 {
    margin-right: 18px;

    .icon {
      @include backgroundImage('member_yuyue.png');
    }
  }
}
</style>
